import React, { useState } from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';
import './App.css';
import logo from './assets/logo.png';
import { ToastProvider } from './components/Toast';
import DocsModal from './components/DocsModal';
import HomePage from './components/HomePage';
import ComparePage from './components/ComparePage';
import { Coffee, HelpCircle, GitCompareArrows, ScanSearch } from 'lucide-react';

function App() {
  const [showDocs, setShowDocs] = useState(false);

  return (
    <ToastProvider>
      <div className="app">
        <header className="header">
          <a href="https://alienrobot.com" className="logo">
            <img src={logo} alt="DOTO Logo" />
          </a>
          <div className="header-text">
            <h1>MetaProbe</h1>
            <span className="tagline">AI Media Metadata Extractor</span>
          </div>
          <nav className="header-nav">
            <NavLink to="/" end className={({ isActive }) => `nav-link ${isActive ? 'nav-active' : ''}`}>
              <ScanSearch size={14} />
              <span>Analyze</span>
            </NavLink>
            <NavLink to="/compare" className={({ isActive }) => `nav-link ${isActive ? 'nav-active' : ''}`}>
              <GitCompareArrows size={14} />
              <span>Compare</span>
            </NavLink>
          </nav>
          <div className="header-actions">
            <button className="docs-btn" onClick={() => setShowDocs(true)}>
              <HelpCircle size={16} /> Docs
            </button>
            <span className="version-badge">v1.3</span>
          </div>
        </header>

        <main className="main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/compare" element={<ComparePage />} />
          </Routes>
        </main>

        <footer className="footer">
          <div className="footer-content">
            <span className="footer-copyright">
              © 2025 <a href="https://www.alienrobot.com" target="_blank" rel="noopener noreferrer">ALIENROBOT</a>
            </span>
            <div className="footer-links">
              <a
                href="https://ko-fi.com/alienrobot"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-icon-link"
                title="Buy me a coffee"
              >
                <Coffee size={16} />
              </a>
            </div>
          </div>
        </footer>
      </div>
      <DocsModal isOpen={showDocs} onClose={() => setShowDocs(false)} />
    </ToastProvider>
  );
}

export default App;